<div class="wrapper">
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <app-property-selector-item
    *ngFor="let prop of availableProps"
    [prop]="prop"
    [selectedProps]="selectedProps"
    (selectedChangesEvent)="selectedEvent($event)"
  ></app-property-selector-item>
</div>
